/* Opskriftskort: skalering af mængder, afkrydsning og læg i kurv. */
(() => {
  const BROEKER = { '½': 0.5, '¼': 0.25, '¾': 0.75, '⅓': 1 / 3, '⅔': 2 / 3 };
  const SMAA = ['tsk', 'tsk.', 'spsk', 'spsk.', 'knsp', 'knsp.', 'tsp', 'tsp.', 'tbsp', 'tbsp.', 'pinch'];
  const HELE = ['g', 'gram', 'ml', 'kg', 'stk', 'stk.'];
  // "1,5 dl" · "½ tsk" · "1 ½ tsk" · "2-3 spsk" · "500g"
  const MAENGDE = /^\s*(\d+(?:[.,]\d+)?\s*[½¼¾⅓⅔]?|[½¼¾⅓⅔])(?:\s*[-–]\s*(\d+(?:[.,]\d+)?))?\s*/;

  const tal = (s) => {
    s = s.replace(/\s+/g, '');
    const b = s.match(/[½¼¾⅓⅔]/);
    const heltal = parseFloat(s.replace(/[½¼¾⅓⅔]/, '').replace(',', '.')) || 0;
    return heltal + (b ? BROEKER[b[0]] : 0);
  };

  const formater = (v, enhed, sprog) => {
    const e = (enhed || '').toLowerCase();
    if (HELE.includes(e) || (e === '' && v >= 10)) return String(Math.round(v));
    if (SMAA.includes(e)) {
      const q = Math.round(v * 4) / 4;
      const hel = Math.floor(q);
      const rest = { 0.25: '¼', 0.5: '½', 0.75: '¾' }[+(q - hel).toFixed(2)] || '';
      if (!hel && !rest) return '¼';
      return (hel ? hel + (rest ? ' ' : '') : '') + rest;
    }
    const r = v >= 10 ? Math.round(v) : Math.round(v * 10) / 10;
    return sprog === 'en' ? String(r) : String(r).replace('.', ',');
  };

  const skaler = (kort, antal) => {
    const grund = parseFloat(kort.dataset.grundantal) || 1;
    const faktor = antal / grund;
    kort.querySelectorAll('[data-ingrediens]').forEach((li) => {
      const orig = li.dataset.original;
      const m = orig.match(MAENGDE);
      const maal = li.querySelector('.ok-ing__maengde');
      if (!m) return;
      const efter = orig.slice(m[0].length);
      const kandidat = ((efter.match(/^([a-zæøå]+\.?)(?=\s|$|\()/i) || [])[1] || '').toLowerCase();
      const enhed = HELE.includes(kandidat) || SMAA.includes(kandidat) ? kandidat : '';
      const sprog = kort.dataset.sprog;
      let ny = formater(tal(m[1]) * faktor, enhed, sprog);
      if (m[2]) ny += '-' + formater(tal(m[2]) * faktor, enhed, sprog);
      maal.textContent = ny;
    });
    kort.querySelector('[data-antal-vis]').textContent = antal;
    const enhed = kort.querySelector('[data-enhed]');
    if (enhed) enhed.textContent = antal === 1 ? enhed.dataset.ental : enhed.dataset.flertal;
  };

  const initKort = (kort) => {
    // Del hver ingredienslinje op i mængde og resten, så mængden kan skaleres.
    kort.querySelectorAll('[data-ingrediens]').forEach((li) => {
      const tekst = li.querySelector('.ok-ing__tekst');
      const orig = tekst.textContent.trim();
      li.dataset.original = orig;
      const m = orig.match(MAENGDE);
      if (!m) return;
      const maengde = m[0].trimEnd();
      tekst.textContent = '';
      const maal = document.createElement('span');
      maal.className = 'ok-ing__maengde';
      maal.textContent = maengde.trim();
      tekst.append(maal, document.createTextNode(orig.slice(maengde.length)));
    });

    let antal = parseFloat(kort.dataset.grundantal) || 1;
    const min = 1, max = 50;
    kort.querySelectorAll('[data-antal]').forEach((knap) => {
      knap.addEventListener('click', () => {
        antal = Math.min(max, Math.max(min, antal + Number(knap.dataset.antal)));
        skaler(kort, antal);
      });
    });

    // Afkrydsning af ingredienser og trin huskes pr. opskrift i denne browser.
    const noegle = 'opskrift:' + kort.dataset.opskrift;
    let gemt = {};
    try { gemt = JSON.parse(localStorage.getItem(noegle) || '{}'); } catch (e) {}
    kort.querySelectorAll('[data-afkryds]').forEach((el) => {
      const id = el.dataset.afkryds;
      const opdater = (v) => {
        el.classList.toggle('er-afkrydset', v);
        el.setAttribute('aria-checked', v ? 'true' : 'false');
      };
      opdater(!!gemt[id]);
      const skift = () => {
        gemt[id] = !gemt[id];
        opdater(gemt[id]);
        try { localStorage.setItem(noegle, JSON.stringify(gemt)); } catch (e) {}
      };
      el.addEventListener('click', skift);
      el.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); skift(); }
      });
    });
    const nulstil = kort.querySelector('[data-nulstil]');
    if (nulstil) nulstil.addEventListener('click', () => {
      gemt = {};
      try { localStorage.removeItem(noegle); } catch (e) {}
      kort.querySelectorAll('[data-afkryds]').forEach((el) => {
        el.classList.remove('er-afkrydset');
        el.setAttribute('aria-checked', 'false');
      });
    });

    kort.querySelectorAll('[data-laeg-i-kurv]').forEach((knap) => {
      knap.addEventListener('click', async () => {
        if (knap.disabled) return;
        const tekst = knap.textContent;
        knap.disabled = true;
        knap.textContent = kort.dataset.tLaegger;
        try {
          const svar = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(knap.dataset.variant), quantity: 1 }] }),
          });
          if (!svar.ok) throw new Error('fejl');
          knap.textContent = kort.dataset.tLagt;
          knap.classList.add('er-lagt');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          const link = knap.parentElement.querySelector('.ok-vare__kurv');
          if (link) link.hidden = false;
        } catch (e) {
          knap.textContent = kort.dataset.tIgen;
          knap.disabled = false;
          setTimeout(() => { knap.textContent = tekst; }, 2500);
        }
      });
    });

    const print = kort.querySelector('[data-print]');
    if (print) print.addEventListener('click', () => window.print());
  };

  const start = () => document.querySelectorAll('[data-opskriftskort]').forEach(initKort);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
